module.exports = __webpack_public_path__ + "img/02_full.7cd6296b.jpg";